import { sizeByID, sizeCreate, sizeDestroy, sizeList, sizeUpdate } from '@/services/agency/ad-sizes.service'

export default {
	namespaced: true,
	state: {
		// SERVICE SIZE
		sizeList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		size: {},

		// STATUS SERVICE SIZE
		sizeStatus: 'pending',
		sizeSaveStatus: 'init',
		sizeDeleteStatus: 'init',
	},
	getters: {
		// SERVICE SIZE
		getSizeList(state) {
			return state.sizeList
		},
		getSize(state) {
			return state.size
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE SIZE
		getSizeDeleteStatus(state) {
			return state.sizeDeleteStatus
		},
		getSizeSaveStatus(state) {
			return state.sizeSaveStatus
		},
		getSizeStatus(state) {
			return state.sizeStatus
		},
	},
	mutations: {
		// SERVICE SIZE
		SIZE_LIST(state, value) {
			state.sizeList = value
		},
		SET_SIZE(state, value) {
			state.size = value
		},

		// STATUS SERVICE SIZE
		SIZE_STATUS(state, value) {
			state.sizeStatus = value
		},
		SIZE_SAVE_STATUS(state, value) {
			state.sizeSaveStatus = value
		},
		SIZE_DELETE_STATUS(state, value) {
			state.sizeDeleteStatus = value
		},
	},
	actions: {
		// Service Size
		async fetchSizeList({ commit }, params) {
			commit('SIZE_STATUS', 'pending')
			commit('SIZE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await sizeList(params)
				commit('SIZE_STATUS', 'init')
				commit('SIZE_LIST', data)
				return data
			} catch (error) {
				commit('SIZE_STATUS', 'init')
				throw error
			}
		},
		async fetchSizeByID({ commit }, params) {
			commit('SIZE_STATUS', 'pending')
			try {
				const { data } = await sizeByID(params)
				commit('SIZE_STATUS', 'init')
				commit('SET_SIZE', data.data)
				return data
			} catch (error) {
				commit('SIZE_STATUS', 'init')

				return error
			}
		},
		async saveNewSize({ commit }, params) {
			commit('SIZE_SAVE_STATUS', 'pending')
			try {
				const { data } = await sizeCreate(params)
				commit('SIZE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SIZE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateSize({ commit }, params) {
			commit('SIZE_SAVE_STATUS', 'pending')
			try {
				const { data } = await sizeUpdate(params)
				commit('SIZE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SIZE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteSizeByID({ commit }, params) {
			commit('SIZE_DELETE_STATUS', 'pending')
			try {
				const { data } = await sizeDestroy(params)
				commit('SIZE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SIZE_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
